import { render, staticRenderFns } from "./the-market-selector.vue?vue&type=template&id=ddef9d3c&"
import script from "./the-market-selector.vue?vue&type=script&lang=js&"
export * from "./the-market-selector.vue?vue&type=script&lang=js&"
import style0 from "./the-market-selector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports